// extracted by mini-css-extract-plugin
export var alignStart = "SummaryPod-module--alignStart--eb945";
export var clickableTile = "SummaryPod-module--clickableTile--73324";
export var content = "SummaryPod-module--content--b7d7e";
export var ctaContainer = "SummaryPod-module--ctaContainer--a5fef";
export var imageContainer = "SummaryPod-module--imageContainer--7dce6";
export var summaryPod = "SummaryPod-module--summaryPod--d264c";
export var text = "SummaryPod-module--text--67448";
export var textContainer = "SummaryPod-module--textContainer--235b0";